import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import Translator from "./translator/translator";
import Catalog from "./catalog/catalog";
import actions from "./actions/export";
import {
  capitalizeWords,
  hasDataInLayers,
  objectsMap,
} from "./utils/objects-utils";
import AppLogo from "./assets/app-logo.png";
import {
  ToolbarComponents,
  Content,
  SidebarComponents,
  FooterBarComponents,
} from "./components/export";
import { VERSION } from "./version";
import "./styles/export";
import Catalogbar from "./components/catalog-bar/catalogbar";
import { Seq } from "immutable";
import "./app.css";
import { API_REQUEST_START, MODE_FINISHING_PLAN, VIEW_ONLY } from "./constants";
import { fraRemoteLog, fraRemoteLogError } from "./utils/fra-remote-log";
const { Toolbar } = ToolbarComponents;
const { Sidebar } = SidebarComponents;
const { FooterBar } = FooterBarComponents;

const toolbarW = 200;
const sidebarW = 300;
const catalogbarW = 230;
const footerBarH = 20;
const logoH = 50;
const wrapperStyle = {
  display: "flex",
  flexFlow: "column nowrap",
};
// const handleBeforeUnload = (event,state) => {
//   // Cancel the event (if needed)
//   event.preventDefault();
//
//   // Chrome requires returnValue to be set
//   const searchParams = new URLSearchParams(window.location.search);
//   const floorId = searchParams.get("floorId");
//   const token = searchParams.get("token");
//   localStorage.setItem(
//     "react-planner_v0",
//     JSON.stringify({ ...state.scene.toJS(), floorId, token })
//   );
//
//   event.returnValue = "";
//   // Your custom logic here
// };

class ReactPlanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonClicked: false,
      progress: 0,
    };
    this.componentRef = React.createRef();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleDownloadPDFClick = this.handleDownloadPDFClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Only update if the relevant props or state have changed
    if (
      nextProps.width !== this.props.width ||
      nextProps.height !== this.props.height ||
      nextProps.state !== this.props.state ||
      nextProps.stateExtractor !== this.props.stateExtractor ||
      nextState.buttonClicked !== this.state.buttonClicked
    ) {
      return true;
    }
    return false;
  }

  getChildContext() {
    return {
      ...objectsMap(actions, (actionNamespace) => this.props[actionNamespace]),
      translator: this.props.translator,
      catalog: this.props.catalog,
    };
  }

  componentWillMount() {
    let { store } = this.context;
    let { projectActions, catalog, stateExtractor, plugins } = this.props;
    plugins.forEach((plugin) => plugin(store, stateExtractor));
    projectActions.initCatalog(catalog);
    const searchParams = new URLSearchParams(window.location.search);
    const viewOnly = searchParams.get("viewOnly");
    if (viewOnly) {
      projectActions.setMode(VIEW_ONLY);
    }
    window.addEventListener("beforeunload", (e) =>
      this.handleBeforeUnload(e, stateExtractor, store)
    );
  }
  componentWillUnmount() {
    window.removeEventListener("beforeunload", (e) =>
      this.handleBeforeUnload(e, stateExtractor, store)
    );
  }

  componentWillReceiveProps(nextProps) {
    let { stateExtractor, state, projectActions, catalog } = nextProps;
    let plannerState = stateExtractor(state);
    let catalogReady = plannerState.getIn(["catalog", "ready"]);
    if (!catalogReady) {
      projectActions.initCatalog(catalog);
    }
  }

  handleBeforeUnload(event, stateExtractor, store) {
    event.preventDefault();
    let state = stateExtractor(store.getState());
    //
    // Chrome requires returnValue to be set
    const searchParams = new URLSearchParams(window.location.search);
    const floorId = searchParams.get("floorId");
    const token = searchParams.get("token");
    if (hasDataInLayers(state.scene.toJS())) {
      localStorage.setItem(
        "react-planner_v0",
        JSON.stringify({ ...state.scene.toJS(), floorId, token })
      );
    }
    event.returnValue =
      "Are you sure you want to leave? Your changes have been temporary saved just in case.";
  }
  eventOnButtonClick(fn) {
    return fn;
  }
  handleButtonClick() {
    this.setState({ buttonClicked: !this.state.buttonClicked });
    this.handleDownload();
  }

  handleDownload() {
    html2canvas(this.componentRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        // console.log();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.componentRef.current.getAttribute(
          "data-bs-floorId"
        )}.png`;
        link.click();
      });
      // const imgData = canvas.toDataURL("image/png");
      // const pdf = new jsPDF();
      // const imgProps = pdf.getImageProperties(imgData);
      // const pdfWidth = pdf.internal.pageSize.getWidth();
      // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      // pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      // const fileName = `${this.componentRef.current.getAttribute(
      //   "data-bs-floorId"
      // )}.pdf`;
      // pdf.save(fileName);
    });
  }

  handlePDFDownload() {
    const { stateExtractor, state, sceneActions, projectActions } = this.props;
    const plannerState = stateExtractor(state);
    const layers = plannerState.getIn(["scene", "layers"]);
    const originalLayerID = plannerState.getIn(["scene", "selectedLayer"]);

    fraRemoteLog("PDF_START", {
      floorCount: layers ? layers.size : 0,
      selectedLayer: originalLayerID,
    });

    // Ensure finishing mode so handles/guides are hidden in the capture.
    if (plannerState.get("mode") !== MODE_FINISHING_PLAN && projectActions) {
      projectActions.openFinishing();
    }

    // Sort layers by altitude so floors are in correct order (ground → top)
    const sortedLayerIDs = layers
      .valueSeq()
      .sortBy((l) => l.get("altitude"))
      .map((l) => l.get("id"))
      .toArray();

    let pdf = null;
    let currentIndex = 0;

    const waitForPaint = (ms) =>
      new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(resolve, ms);
          });
        });
      });

    // Blank = no black wall ink. Colored evacuation sidebar alone must NOT
    // count as a valid floor page (that caused white plan + fake "ok" pages).
    const isBlankCanvas = (canvas) => {
      if (!canvas || canvas.width < 20 || canvas.height < 20) return true;
      try {
        const ctx = canvas.getContext("2d");
        const { width: w, height: h } = canvas;
        const step = 10;
        const data = ctx.getImageData(0, 0, w, h).data;
        let dark = 0;
        for (let y = 0; y < h; y += step) {
          for (let x = 0; x < w; x += step) {
            const i = (y * w + x) * 4;
            if (data[i] < 45 && data[i + 1] < 45 && data[i + 2] < 45) {
              dark += 1;
            }
          }
        }
        return dark < 20;
      } catch (err) {
        return false;
      }
    };

    // Client PDF issue: plan was tiny in the corner with huge white margins.
    // Trim empty edges so each page is tight around the floor + legend.
    const trimWhiteMargins = (canvas) => {
      try {
        const ctx = canvas.getContext("2d");
        const { width: w, height: h } = canvas;
        const data = ctx.getImageData(0, 0, w, h).data;
        let top = h;
        let left = w;
        let right = 0;
        let bottom = 0;
        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const i = (y * w + x) * 4;
            if (data[i] < 250 || data[i + 1] < 250 || data[i + 2] < 250) {
              if (x < left) left = x;
              if (x > right) right = x;
              if (y < top) top = y;
              if (y > bottom) bottom = y;
            }
          }
        }
        if (right <= left || bottom <= top) return canvas;
        const pad = 24;
        left = Math.max(0, left - pad);
        top = Math.max(0, top - pad);
        right = Math.min(w - 1, right + pad);
        bottom = Math.min(h - 1, bottom + pad);
        const tw = right - left + 1;
        const th = bottom - top + 1;
        if (tw < 40 || th < 40) return canvas;
        const out = document.createElement("canvas");
        out.width = tw;
        out.height = th;
        out.getContext("2d").drawImage(canvas, left, top, tw, th, 0, 0, tw, th);
        return out;
      } catch (err) {
        return canvas;
      }
    };

    const captureFloor = async (layerID, attempt) => {
      sceneActions.selectLayer(layerID);
      // Wait for Redux + React + camera fit useEffect (was too short → blank pages).
      await waitForPaint(attempt === 0 ? 2000 : 3000);

      if (!this.componentRef.current) {
        return null;
      }

      let canvas = null;
      try {
        canvas = await html2canvas(this.componentRef.current, {
          backgroundColor: "#ffffff",
          scale: 1.5,
          useCORS: true,
          logging: false,
          allowTaint: true,
          foreignObjectRendering: false,
          imageTimeout: 15000,
          onclone: (clonedDoc) => {
            // Kill styles that cause html2canvas ghost/double text over the plan.
            clonedDoc.querySelectorAll("*").forEach((el) => {
              try {
                const s = el.style;
                if (!s) return;
                s.textShadow = "none";
                s.boxShadow = "none";
                s.filter = "none";
                if (s.opacity && parseFloat(s.opacity) < 1) {
                  s.opacity = "1";
                }
              } catch (e) {
                /* ignore */
              }
            });
          },
        });
      } catch (err) {
        console.error("html2canvas failed", layerID, err);
        fraRemoteLogError("html2canvas", err, { layerId: layerID, attempt });
        canvas = null;
      }

      if ((!canvas || isBlankCanvas(canvas)) && attempt < 3) {
        return captureFloor(layerID, attempt + 1);
      }
      if (!canvas || isBlankCanvas(canvas)) {
        fraRemoteLog("PDF_FLOOR_BLANK", { layerId: layerID, attempt });
        return null;
      }
      return trimWhiteMargins(canvas);
    };

    // Capture all floors first, then build PDF (avoids empty first page).
    const pages = [];

    const finishPdf = () => {
      if (!pages.length) {
        console.error("PDF: no floors captured");
        fraRemoteLog("PDF_EMPTY", { reason: "no floors captured" });
        sceneActions.selectLayer(originalLayerID);
        return;
      }

      pages.forEach((page, index) => {
        const { imgData, imgWidth, imgHeight } = page;
        if (index === 0) {
          pdf = new jsPDF({
            orientation: imgWidth > imgHeight ? "landscape" : "portrait",
            unit: "px",
            format: [imgWidth, imgHeight],
            compress: true,
          });
        } else {
          pdf.addPage(
            [imgWidth, imgHeight],
            imgWidth > imgHeight ? "landscape" : "portrait"
          );
        }
        pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      });

      pdf.save("floorplan-all-floors.pdf");
      fraRemoteLog("PDF_DONE", {
        pages: pages.length,
        floors: pages.map((p) => p.layerID),
      });
      sceneActions.selectLayer(originalLayerID);
    };

    const captureNextFloor = async () => {
      if (currentIndex >= sortedLayerIDs.length) {
        finishPdf();
        return;
      }

      const layerID = sortedLayerIDs[currentIndex];
      const layerMeta = layers.get(layerID);
      const lineCount = layerMeta && layerMeta.get("lines")
        ? layerMeta.get("lines").size
        : 0;
      if (!lineCount) {
        currentIndex += 1;
        captureNextFloor();
        return;
      }

      try {
        const canvas = await captureFloor(layerID, 0);
        if (
          canvas &&
          canvas.width > 40 &&
          canvas.height > 40 &&
          !isBlankCanvas(canvas)
        ) {
          // JPEG avoids jsPDF PNG soft-mask bug (Chrome shows white page).
          const imgData = canvas.toDataURL("image/jpeg", 0.92);
          if (imgData && imgData.length > 5000) {
            pages.push({
              imgData,
              imgWidth: canvas.width,
              imgHeight: canvas.height,
              layerID,
            });
          }
        }
      } catch (err) {
        console.error("PDF floor capture failed", layerID, err);
      }

      currentIndex += 1;
      waitForPaint(600).then(() => captureNextFloor());
    };

    waitForPaint(1200).then(() => captureNextFloor());
  }

  handleDownloadPDFClick() {
    this.handlePDFDownload();
  }

  render() {
    let { width, height, state, stateExtractor, ...props } = this.props;
    let contentW = width - toolbarW;
    let toolbarH = height - footerBarH;
    let contentH = height - footerBarH;
    let sidebarH = height - logoH;
    let catalogBarH = contentH - logoH;
    let extractedState = stateExtractor(state);
    let selectedLayer = extractedState.getIn(["scene", "selectedLayer"]);

    //TODO change in multi-layer check
    let selected = extractedState.getIn([
      "scene",
      "layers",
      selectedLayer,
      "selected",
    ]);

    let multiselected =
      selected.lines.size > 1 ||
      selected.items.size > 1 ||
      selected.holes.size > 1 ||
      selected.areas.size > 1 ||
      selected.lines.size +
        selected.items.size +
        selected.holes.size +
        selected.areas.size >
        1;
    return (
      <div style={{ ...wrapperStyle }}>
        {extractedState.get("mode") !== MODE_FINISHING_PLAN && (
          <p
            style={{
              position: "absolute",
              zIndex: 99999,
              left: "55.5%",
              top: "6%",
            }}
          >
            <b>
              {capitalizeWords(
                extractedState.getIn([
                  "scene",
                  "layers",
                  selectedLayer,
                  "visibleName",
                ])
              )}
            </b>
          </p>
        )}
        {extractedState.get("mode") === VIEW_ONLY ? (
          <div
            style={{
              display: "flex",
              flexFlow: "row nowrap",
              overflow: "hidden",
              height: contentH,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: catalogbarW,
                flexShrink: 0,
                height: contentH,
                overflow: "hidden",
              }}
            >
              <div style={{ height: logoH, textAlign: "center", flexShrink: 0 }}>
                {/* <a href="http://frawizard-portal.s3-website-us-east-1.amazonaws.com/"> */}
                {" "}
                <img src={AppLogo} alt="" height={logoH} />
              {/* </a> */}
              </div>
              <Catalogbar
                width={catalogbarW}
                height={catalogBarH}
                mode={extractedState.get("mode")}
                state={extractedState}
                downloadpng={this.handleButtonClick}
                {...props}
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <Content
                width={contentW}
                height={contentH}
                state={extractedState}
                buttonClicked={this.state.buttonClicked}
                {...props}
                onWheel={(e) => {
                  e.stopPropagation();
                }}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexFlow: "row nowrap",
              overflow: "hidden",
              height: contentH,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: catalogbarW,
                flexShrink: 0,
                height: contentH,
                overflow: "hidden",
              }}
            >
              <div style={{ height: logoH, textAlign: "center", flexShrink: 0 }}>
                {/* <a href="http://frawizard-portal.s3-website-us-east-1.amazonaws.com/"> */}
                {" "}
                <img src={AppLogo} alt="" height={logoH} />
              {/* </a> */}
              </div>
              <Catalogbar
                width={catalogbarW}
                modeFinish={extractedState.get("mode") === MODE_FINISHING_PLAN}
                mode={extractedState.get("mode")}
                height={catalogBarH}
                downloadpng={this.handleButtonClick}
                downloadPDF={this.handleDownloadPDFClick}
                state={extractedState}
                {...props}
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 0,
                height: contentH,
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Toolbar
                width={"100%"}
                height={toolbarH}
                state={extractedState}
                {...props}
              />
              <Content
                width={contentW}
                height={height}
                state={extractedState}
                {...props}
                componentRef={this.componentRef}
                onWheel={(e) => {
                  e.stopPropagation();
                }}
              />
              <Sidebar
                width={sidebarW}
                opened={
                  (!multiselected &&
                    extractedState.mode === "MODE_IDLE" &&
                    extractedState.scene.layers
                      .get(selectedLayer)
                      .selected.valueSeq()
                      .some((layer) => layer.size > 0)) ||
                  (!multiselected && extractedState.mode === "SELECT_GUIDE")
                }
                height={contentH}
                state={extractedState}
                {...props}
              />
            </div>
            {extractedState.mode !== MODE_FINISHING_PLAN && (
              <FooterBar
                width={width}
                height={footerBarH}
                state={extractedState}
                {...props}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

ReactPlanner.propTypes = {
  translator: PropTypes.instanceOf(Translator),
  catalog: PropTypes.instanceOf(Catalog),
  allowProjectFileSupport: PropTypes.bool,
  plugins: PropTypes.arrayOf(PropTypes.func),
  autosaveKey: PropTypes.string,
  autosaveDelay: PropTypes.number,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  stateExtractor: PropTypes.func.isRequired,
  toolbarButtons: PropTypes.array,
  sidebarComponents: PropTypes.array,
  footerbarComponents: PropTypes.array,
  customContents: PropTypes.object,
  softwareSignature: PropTypes.string,
};

ReactPlanner.contextTypes = {
  store: PropTypes.object.isRequired,
};

ReactPlanner.childContextTypes = {
  ...objectsMap(actions, () => PropTypes.object),
  translator: PropTypes.object,
  catalog: PropTypes.object,
};

ReactPlanner.defaultProps = {
  translator: new Translator(),
  catalog: new Catalog(),
  plugins: [],
  allowProjectFileSupport: true,
  softwareSignature: `React-Planner ${VERSION}`,
  toolbarButtons: [],
  sidebarComponents: [],
  footerbarComponents: [],
  customContents: {},
};

//redux connect
function mapStateToProps(reduxState) {
  return {
    state: reduxState,
  };
}

function mapDispatchToProps(dispatch) {
  return objectsMap(actions, (actionNamespace) =>
    bindActionCreators(actions[actionNamespace], dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReactPlanner);
